import React, { useState } from 'react';
import Alert from '@mui/material/Alert';
import { Input, Table, Layout, Spin, message, Row, Col, Space, notification, Tabs, Typography } from 'antd';
import Button from '@mui/material/Button';
import { KeyboardDoubleArrowRightRounded, CloseRounded } from "@mui/icons-material";
import { useTickerSearch } from './hooks'; // Adjust the path as necessary
import SelectedItem from './SelectedItem'; // Adjust the path as necessary
import { isCallable } from "../../../utils/typeCheck";
import TickerChip from "../../../components/TickerChip"; // Adjust the path as necessary

const { Content, Footer } = Layout;

const { TabPane } = Tabs;

const TickerSearch = ({ onTickersSubmit,
                        closeSearch,
                        types = ['stock', 'etf', 'mf', 'factor'],
                        maxTickers = null,
                        initialSymbols = []
}) => {
  const [filterType, setFilterType] = useState(types.length > 1 ? 'All' : types[0].toLowerCase());
  const {
    tickers, loading, error,
    selectedTickers,
    handleAddOrRemoveTicker,
    handleRemoveTicker,
    debouncedSearchTermUpdate
  } = useTickerSearch({initialSymbols});
  const filteredTickers = tickers.filter(ticker => filterType === 'All' || filterType === ticker.type)
    .sort((a, b) => (b.mktcap || 0) - (a.mktcap || 0));

  const columns = [
    {
      title: 'Security',
      key: 'ticker',
      render: (_, record) => <TickerChip ticker={record} />,
    }
  ];

  const getRowClassName = (record) => {
    return selectedTickers.some(t => t.symbol === record.symbol) ? 'flag--info cursor' : 'cursor';
  }

  const handleSearchChange = (e) => {
    debouncedSearchTermUpdate(e.target.value);
  };

  const handleTypeFilterChange = (key) => {
    if (key === 'close'){
      closeSearch?.();
      return;
    }
    setFilterType(key === 'All' ? 'All' : key.toLowerCase());
  };
    const handleSubmit = () => onTickersSubmit(selectedTickers);

  const clearAllSelected = () => {
    selectedTickers.forEach(ticker => handleRemoveTicker(ticker.symbol));
  };


  const handleAddOrRemoveTickerWithLimit = (ticker) => {
    if (maxTickers !== null && selectedTickers.length >= maxTickers && !selectedTickers.some(t => t.symbol === ticker.symbol)) {
      notification.warning({
        message: 'Maximum Tickers Limit',
        description: `You have reached the maximum limit of ${maxTickers} tickers.`,
      });
      return;
    }
    handleAddOrRemoveTicker(ticker);
  };

  if (error) {
    message.error('Failed to load tickers');
    return null;
  }

  return (
    <Layout style={{ maxWidth: 1000, margin: '0 auto' }}>
      <Content style={{ padding: '20px', height: '60vh' }}>
        {closeSearch && (
            <div className={'text-center my-2'}>
              <div className={'text-lg font-semibold text-rose-500 cursor-pointer'} onClick={closeSearch}>
                Close Search
              </div>
            </div>
        )}
        <Row justify="space-between" align="middle" style={{ marginBottom: '15px' }}>
          <Input
            placeholder="Search by Ticker or Name"
            onChange={handleSearchChange}
            size="large"
            loading={loading}
          />
        </Row>
        <Row wrap={false} align={'top'}>
          <Col flex={'0 0 100px'}>
            <Tabs tabPosition="left" defaultActiveKey={filterType} onChange={handleTypeFilterChange} style={{ marginBottom: '20px' }}>
              {types.length > 1 && <TabPane tab="ALL" key="All" />}
              {types.map(type => <TabPane tab={type.toUpperCase()} key={type.toUpperCase()} />)}
            </Tabs>
          </Col>
          <Col flex={'1'}>
            <Table
              columns={columns}
              dataSource={filteredTickers}
              rowKey="symbol"
              pagination={{ pageSize: 25, position: ['bottomRight'], showLessItems: true }}
              scroll={{ y: '40vh' }}
              size={'middle'}
              onRow={(record) => ({
                onClick: () => handleAddOrRemoveTickerWithLimit(record),
              })}
            />
          </Col>
        </Row>
      </Content>
      <Footer className={'bg-gradient-to-b from-gray-100 to-zinc-50'} style={{
        position: 'relative',
        bottom: 0,
        width: '100%',
        padding: '10px 20px',
        boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.1)'
      }}>
          <Space direction={'vertical'} style={{width: '100%'}}>
            <Space>
              <Button variant="contained" color="info" onClick={handleSubmit}>
                Continue ({selectedTickers.length})
              </Button>
              <Button variant="outlined" color="error" onClick={clearAllSelected}>
                Clear All
              </Button>
            </Space>
            <Space wrap>
              {selectedTickers.map(ticker => (
                <SelectedItem key={ticker.symbol} ticker={ticker} onRemove={handleRemoveTicker} />
              ))}
            </Space>
          </Space>
      </Footer>
    </Layout>
  );
};

export default TickerSearch;
